module.exports = __webpack_public_path__ + "static/media/mobileuoa.29085b1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Modals/UOAModal/mobileuoa.png
// module id = 984
// module chunks = 0